import * as React from 'react';
import update from 'immutability-helper';
import { SERVER_IP, httpOption } from '../../Util/Config';
import { ButtonBase, CircularProgress } from '@material-ui/core';
import { reset as Language } from '../../Util/language.json';
import FormContainer from '../../components/Form/FormContainer';
import { Link } from 'react-router-dom';
import FormInput from '../../components/Form/FormInput';
/* eslint no-useless-escape: 0 */
const regexEmailAndSkyStream = /(^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|^(S)+[0-9]{5,6})/i;

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      error: null,
      isLoading: false,
      isSendSuccess: false,
    };
    this.handlerInputChange = this.handlerInputChange.bind(this);
    this.handlerSubmit = this.handlerSubmit.bind(this);
  }

  handlerInputChange(e) {
    const { name, value } = e.target;

    this.setState(
      update(this.state, {
        [name]: { $set: value },
        error: { $set: null },
      }),
    );
  }

  handlerSubmit(e) {
    e.preventDefault();
    const { email } = this.state;
    if (!regexEmailAndSkyStream.test(email)) {
      return;
    }
    this.setState(update(this.state, { isLoading: { $set: true } }));
    window.$.ajax({
      url: `${SERVER_IP}/cli/user/forgot`,
      type: 'post',
      ...httpOption,
      data: {
        email,
      },
    }).then(res => {
      if (res.status === 200) {
        this.setState(
          update(this.state, {
            isLoading: { $set: false },
            isSendSuccess: { $set: true },
          }),
        );
      } else {
        this.setState(
          update(this.state, {
            error: {
              $set: Language.errNotFoundEmail,
            },
          }),
        );
        this.setState(update(this.state, { isLoading: { $set: false } }));
      }
    });
  }

  render() {
    const { email, error, isLoading, isSendSuccess } = this.state;
    return (
      <FormContainer id="page--password-reset" caption={Language.caption}>
        <div
          className="msg"
          dangerouslySetInnerHTML={{ __html: Language.info }}
        />
        <form className="sign" onSubmit={this.handlerSubmit}>
          <FormInput
            idForm
            name="email"
            type="text"
            value={email}
            placeholder={Language.email}
            className={error ? 'error' : ''}
            onChange={this.handlerInputChange}
          />
          {error && (
            <div className="caption color-secondary" style={{ marginTop: 8 }}>
              {error}
            </div>
          )}

          {isLoading && (
            <ButtonBase
              color="primary"
              classes={{ root: 'secondary' }}
              type="submit"
            >
              <div className="progress-container">
                <CircularProgress style={{ color: 'white' }} />
              </div>
            </ButtonBase>
          )}
          {!isLoading && (
            <ButtonBase
              color="primary"
              classes={{ root: 'secondary' }}
              type="submit"
            >
              {isSendSuccess ? Language.mailSendSuccess : Language.sendMail}
            </ButtonBase>
          )}
          <Link className="link" to="/">
            {Language.back}
          </Link>
        </form>
      </FormContainer>
    );
  }
}

export default PasswordReset;
